import { useQuery } from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { getUserInformation } from '~~/src/api/users'

interface Args {
  usersIds: string[]
}

export function useGetUserInformationsQuery(
  args: Args,
  options?: {
    enabled?: MaybeRef<boolean>
  },

) {
  return useQuery({
    queryKey: ['user-informations', args.usersIds] as const,
    queryFn: async ({ queryKey, signal }) => {
      const [_, users] = queryKey
      return await getUserInformation(users, signal)
    },
    ...options,
  })
}
